import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import { lazyWithRetry } from './lazyWithRetry';

const TokenLogin = lazyWithRetry(() => import("../pages/login/TokenLogin"));
const EmailLogin = lazyWithRetry(() => import("../pages/login/EmailLogin"));
const PhoneLogin = lazyWithRetry(() => import("../pages/login/PhoneLogin"));
const CreateAccount = lazyWithRetry(() => import("../pages/login/CreateAccount"));
const PasswordForgot = lazyWithRetry(() => import("../pages/PasswordForgot"));
const PasswordReset = lazyWithRetry(() => import("../pages/PasswordReset"));
const SetPassword = lazyWithRetry(() => import("../pages/SetPassword"));
const VerifyEmailPage = lazyWithRetry(() => import("../pages/VerifyEmailPage"));
const LegacyVerifyEmailRedirect = lazyWithRetry(() => import("../pages/LegacyVerifyEmailRedirect"));
const ChooseGenres = lazyWithRetry(() => import("../pages/ChooseGenres"));

export const AuthRoutes = ({ setLanguage }) => [
  <Route key="login" path="login" element={<TokenLogin setLanguage={setLanguage} />} />,
  <Route key="email-login" path="email-login" element={<Navigate to="/login" />} />,
  <Route key="reset-password" path="reset-password" element={<PasswordReset setLanguage={setLanguage} />} />,
  <Route key="password-forgot" path="password-forgot" element={<PasswordForgot setLanguage={setLanguage} />} />,
  <Route key="phone-login" path="phone-login" element={<PhoneLogin setLanguage={setLanguage} />} />,
  <Route key="create-account" path="create-account" element={<CreateAccount setLanguage={setLanguage} />} />,
  <Route key="verify-email" path="verify-email" element={<VerifyEmailPage />} />,
  <Route key="verify-email-legacy" path="verify-email/*" element={<LegacyVerifyEmailRedirect />} />,
  <Route key="choose-genres" path="choose-genres" element={<ChooseGenres setLanguage={setLanguage} />} />,
  <Route key="set-password" path="/set-password" element={<SetPassword />} />
];